import MicroModal                            from '../components/MicroModal.js';

/**
 * Configure and initialize a modal element.
 */
export default function modal() {
	// Define settings for the modal
	const settings = {
		openTrigger         : 'data-modal-open',
		closeTrigger        : 'data-modal-close',
		openClass           : 'is-open',
		disableScroll       : true,
		disableFocus        : true,
		awaitOpenAnimation  : true,
		awaitCloseAnimation : true,
		debugMode           : false,
	};

	// Initialize the modal with defined settings
	MicroModal.init(settings);

	// Add event listener to close button
	const modalCloseLink = document.querySelector('.js-modal-close');
	if (modalCloseLink) {
		modalCloseLink.addEventListener('click', (e) => {
			e.preventDefault();
			const { id } = e.target.dataset;
			if (id) {
				// Close the modal on click
				MicroModal.close(id, settings);
			}
		});
	}
}
